module.exports = __webpack_public_path__ + "a17d279f/img/verified-icon.f93bbc14.svg";